import React, { useState } from "react";
import { Form, Button, Modal, Col, Row } from "antd";
import { observer } from "mobx-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { vsmNotify } from "../../../../config/messages";
import useStore from "../../../../store";

const ApproveComponent = observer((props) => {
	const [form] = Form.useForm();
	const {
		MunicipalReqPendingStore
	} = useStore();

	const [saving, setSaving] = useState();
	// Make function call to approve existing record
	const handleSubmit = (data) => {
		setSaving(true);
		MunicipalReqPendingStore.approveMunicipalRequest(MunicipalReqPendingStore.approveRejectValues?.booking_id)
			.then((data) => {
				vsmNotify.success({
					message: data.STATUS.NOTIFICATION[0],
				});
				close();
			})
			.catch((e) => {
				if (e.errors) {
					vsmNotify.error({
						message: data.STATUS.NOTIFICATION[0],
					});
				}
			})
			.finally(() => {
				setSaving(false);
			});
	};

	// reset form and close add form
	const close = () => {
		props.close();
		form.resetFields();
	};

	return (
		<Modal
			centered
			className="aprroveModal"
			title="Approve Municipal Request"
			zIndex={1005}
			visible={props.visible}
			closeIcon={<FontAwesomeIcon icon={faTimes} />}
			onCancel={props.close}
			cancelButtonProps={{ style: { display: "none" } }}
			okButtonProps={{ style: { display: "none" } }}
			footer={[
				<Button
					key="2"
					htmlType="button"
					className="cancelBtn mr-35"
					onClick={close}
				>
					No
				</Button>,
				<Button
					key="1"
					form="approveMunicipalReqForm"
					loading={saving}
					htmlType="submit"
					type="primary"
				>
					Yes
				</Button>,
			]}
		>
			<Form form={form} id="approveMunicipalReqForm" onFinish={handleSubmit}>
				<Row align="middle">
					<Col span={24} className="text-center">
						<h3>
							Would you like to approve municipal request?
						</h3>
					</Col>
				</Row>
			</Form>
		</Modal>
	);
});

export default ApproveComponent;
